const surveyFAQData = [
  {
    question: "What is land surveying?",
    answer: "Land surveying is the technique, profession, art, and science of determining the terrestrial two-dimensional or three-dimensional positions of points and the distances and angles between them, typically on the surface of the Earth. It's crucial for property boundaries, construction, and mapping."
  },
  {
    question: "Why do I need a land survey?",
    answer: "A land survey is essential for various reasons, including establishing property boundaries, planning construction projects, resolving property disputes, obtaining permits, and ensuring legal compliance for land transactions."
  },
  {
    question: "How long does a land survey take?",
    answer: "The duration of a land survey varies depending on the size and complexity of the plot, terrain, weather conditions, and the specific type of survey required. We provide an estimated timeline after assessing your request."
  },
  {
    question: "What information do I need to provide for a survey request?",
    answer: "To request a survey, you'll need to provide contact information, the plot's address/location, estimated area, and any specific requirements or observations. Plot ID and owner name are helpful if known."
  },
  {
    question: "What kind of reports will I receive?",
    answer: "You will receive comprehensive reports including boundary lines, topographical features, land usage analysis, and any other relevant data collected during the survey. We ensure reports are clear and actionable."
  }
];

export default surveyFAQData;